import {
    LinkedInIcon,
    TwitterIcon,
    FacebookIcon,
    InstagramIcon,
    WechatIcon,
  } from "../../Icons"
import { SocialMediaIcon } from "../../Icons/SocialMediaIcon"
import { SocialMedia } from "../Footer.styles"

export const SocialMediaComponent = (props: { mobile?: boolean }) => {
    const SocialMediaList = [
      {
        url: "https://www.linkedin.com/company/10347780",
        icon: <LinkedInIcon />,
      },
      {
        url: "https://twitter.com/The_Guarantors",
        icon: <TwitterIcon />,
      },
      {
        url: "https://www.facebook.com/TheGuarantors",
        icon: <FacebookIcon />,
      },
      {
        url: "https://www.instagram.com/theguarantors",
        icon: <InstagramIcon />,
      },
      {
        url: "https://www.theguarantors.com/wechat",
        icon: <WechatIcon />,
      },
    ]

    return (
      <SocialMedia {...props}>
        {SocialMediaList.map((props) => (
          <SocialMediaIcon {...props} />
        ))}
      </SocialMedia>
    )
  }